<template>
  <div style="position:sticky;top:0;z-index:3;">
    <logo-vue :configData="configData"></logo-vue>
   </div>
</template>

<script>
import LogoVue from "./logo";
export default {
  props: ["configData"],
  components: {
    LogoVue
  }
};
</script>



// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/personalCenterHead/index.vue